import React, { createContext, useCallback, useState } from "react";
import { message } from "antd";

export const ToastContext = createContext();
export const ToastContextProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const showToast = useCallback(
    (err, isError, otherProps) => {
      const duration = otherProps?.duration ? otherProps.duration / 1000 : 5; // Convert to seconds

      if (isError) {
        messageApi.error({
          content: err,
          duration,
          style: otherProps?.backColor ? { backgroundColor: otherProps.backColor } : {},
        });
      } else {
        messageApi.success({
          content: err,
          duration,
          style: otherProps?.backColor ? { backgroundColor: otherProps.backColor } : {},
        });
      }
    },
    [messageApi]
  );

  const hideToast = useCallback(() => {
    messageApi.destroy();
  }, [messageApi]);

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};
